/**
 * Delete user.
 */
export function deleteUser() {
  const deleteUserModal = $( '.modal-confirm-delete-user' );
  const teamsTable = $( '.m__dashboard-team-table' );
  if ( !deleteUserModal || !teamsTable ) {
    return;
  }

  window.mce = 'mce' in window ? window.mce : {};

  const deleteUserButton = deleteUserModal.find( '.confirm-delete-user' );
  const validationError = deleteUserModal.find( '.modal-share-error' );
  const validationSuccess = deleteUserModal.find( '.modal-share-success' );
  const openDeleteModal = teamsTable.find( '.open-modal-confirm-delete-user' );

  $( openDeleteModal ).on( 'click', function openModal( event ) {
    event.preventDefault();
    var userId = $( this ).attr( 'data-user-id' );
    deleteUserButton.attr( 'data-user-id', userId );
  });

  var formData = {};
  $( deleteUserButton ).on( 'click', function deleteUser( event ) {
    event.preventDefault();

    formData.action = 'delete-user';
    formData.data = {
      user_id:$( this ).data( 'user-id' )
    };

    $.ajax({
      url:`${window.mce.api_url}teams`,
      type:'post',
      data:formData,
      success:function( data ) {
        if ( typeof data.success !== 'undefined' && data.success === true ) {
          validationSuccess.find( 'span' ).text( `User ${data.username} was successfully deleted` );
          setTimeout( function timeoutForReload() {
            window.location.reload();
          }, 2000 );
        } else if ( typeof data.error !== 'undefined' ) {
          validationError.find( 'span' ).text( data.error );
          setTimeout( function removeError() {
            validationError.find( 'span' ).text( '' );
          }, 3000 );
        }
      }
    });
  });
}